<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="FRACIONAMENTO" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/pattern.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/fracionamentos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <hr class="mt-1 mb-2" />
      <div class="form-row mb-2" style="font-size: 18px;">
        <div class="col-sm-6">
          <span class="text-primary"><b>Data: {{entidade.data_cadastro | date:'dd/MM/yyyy':'GMT'}}</b></span>
        </div>
      </div>
      <div class="form-row" style="font-size: 15px;">
        <div class="col-sm-6">
          <span class="text-danger"><b>Saída: #{{entidade.saida?.id}}</b></span>
          <span class="text-success ml-2"><b>Entrada: #{{entidade.entrada?.id}}</b></span>
        </div>
      </div>
      <hr class="mb-3 mt-0">
      <div class="form-row">
        <div class="col-sm-6">
          <p-fieldset legend="Produto a ser fracionado">
            <div class="form-row" formGroupName="fracionar">
              <div class="col-sm-9 form-group">
                <label for="fracionar_prod">Produto</label>
                <input readonly value="{{entidade.fracionar?.produto.codigo}} - {{entidade.fracionar?.produto.nome}}"
                  type="text" class="form-control-plaintext form-control text-center">
              </div>
              <div class="col-sm-3 form-group">
                <label for="fracionar_un">UN.</label>
                <input readonly [value]="entidade.fracionar?.unidade.nome" type="text"
                  class="form-control-plaintext form-control text-center">
              </div>
            </div>
            <div class="form-row">
              <div class="col-sm-9 form-group">
                <label for="fracionar_qtde">Lote/Vencimento.</label>
                <input readonly value="{{entidade.lote}} | {{entidade.vencimento | date:'dd/MM/yyyy':'GMT'}}"
                  type="text" class="form-control-plaintext form-control text-center">
              </div>
              <div class="col-sm-3 form-group">
                <label for="fracionar_qtde">Qtde.</label>
                <input readonly value="{{entidade.qtd_fracionar | number:'1.5-5'}}" type="text"
                  class="form-control-plaintext form-control text-center">
              </div>
            </div>
          </p-fieldset>
        </div>
        <div class="col-sm-6">
          <p-fieldset legend="Produto fracionado">
            <div class="form-row mt-2" formGroupName="fracionado">
              <div class="col-sm-9 form-group">
                <label for="fracionado_prod">Produto</label>
                <input readonly value="{{entidade.fracionado?.produto.codigo}} - {{entidade.fracionado?.produto.nome}}"
                  type="text" class="form-control-plaintext form-control text-center">
              </div>
              <div class="col-sm-3 form-group">
                <label for="fracionado_un">UN.</label>
                <input readonly [value]="entidade.fracionado?.unidade.nome" type="text"
                  class="form-control-plaintext form-control text-center">
              </div>
            </div>
            <div class="form-row">
              <div class="col-sm-9 form-group">
                <label for="favorecido">Fornecedor</label>
                <input readonly [value]="entidade.favorecido?.nome" type="text"
                  class="form-control-plaintext form-control text-center">
              </div>
              <div class="col-sm-3 form-group">
                <label for="fracionado_qtde">Qtde.</label>
                <input readonly value="{{entidade.qtd_fracionado | number:'1.5-5'}}" type="text"
                  class="form-control-plaintext form-control text-center">
              </div>
            </div>
          </p-fieldset>
        </div>
      </div>
      <hr class="mt-2 mb-4" />
      <div class="form-row">
        <div class="col-sm-12 form-group">
          <label for="observacao">Observação</label>
          <textarea readonly [value]="entidade.observacao" class="form-control-plaintext form-control pl-2" id="obs"
            rows="3"></textarea>
        </div>
      </div>
    </form>
    <!-- <pre *ngIf="entidadeForm">{{ entidadeForm.value | json}}</pre> -->
  </div>
</div>